import axios from "axios";

// Proxied via setupProxy.js
const BASE_URL = "/api/image";

async function postImage(action, data) {
  try {
    const response = await axios.post(
      `${BASE_URL}?action=${action}`,
      data,
      {
        timeout: 60000,
      }
    );
    return response.data || {};
  } catch (err) {
    console.error("Image API error", err);
    throw err;
  }
}

export const describeImage = (data) => postImage("describe", data);
export const tagImage = (data) => postImage("tag", data);
export const classifyImage = (data) => postImage("classify", data);
export const sentimentImage = (data) => postImage("sentiment", data);

